import Eyebrow from "../shared/Eyebrow";
import TypedHeading from "../shared/TypedHeading";
import Reveal from "../shared/Reveal";
import useI18n from "../../i18n/useI18n";

const HomeClientsProjectsComponent = () => {
  const { t } = useI18n();
  const items = t("projects.items");
  const visibleItems = Array.isArray(items) ? items.filter((project) => !project.hidden) : [];

  return (
    <section id="projects" className="projects section section--alt">
      <div className="projects__inner">
        <Reveal><Eyebrow>{t("projects.eyebrow")}</Eyebrow></Reveal>
        <TypedHeading text={t("projects.title")} className="projects__title" />
        <Reveal as="p" className="projects__lede">{t("projects.lede")}</Reveal>

        <div className="projects__list">
          {visibleItems.map((project, i) => (
            <Reveal as="article" className="project-row" key={i}>
              <div className="project-row__id">
                <div className="project-row__tag">{project.tag}</div>
                <h3 dir="auto" className="project-row__name">{project.name}</h3>
                {project.url && (
                  <a
                    className="ui-button ui-button--secondary ui-button--sm project-row__link"
                    href={project.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={t("projects.viewAriaLabel").replace("{name}", project.name)}
                  >
                    {t("projects.viewLabel")}
                    <span aria-hidden="true">↗</span>
                  </a>
                )}
              </div>
              <div className="project-row__cols">
                <div className="project-row__col">
                  <div className="project-row__label">{t("projects.challengeLabel")}</div>
                  <p>{project.challenge}</p>
                </div>
                <div className="project-row__col">
                  <div className="project-row__label">{t("projects.solutionLabel")}</div>
                  <p>{project.solution}</p>
                </div>
                <div className="project-row__col project-row__col--outcome">
                  <div className="project-row__label">{t("projects.outcomeLabel")}</div>
                  <p>{project.outcome}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeClientsProjectsComponent;
